(function () {
  'use strict';

  // 2026-06-28 — every external-analytics call is wrapped so a throwing pixel
  // shim (ad-blocker, CSP, misconfigured fbq/gtag) can NEVER propagate into the
  // submit handler and strand the customer before the next question loads.
  //
  // 2026-08-14 — third-party payloads are allowlisted. Consultation answers,
  // conversation history and contact details are first-party data: they may
  // travel only to the Tara Worker, never to Meta, Google, Klaviyo or any
  // other third-party tag. Only the non-identifying keys below may leave.
  var THIRD_PARTY_ALLOWED_KEYS = [
    'content_name',
    'question_number',
    'total_questions',
    'input_type',
    'contact_type',
  ];

  function sanitizeThirdPartyPayload(data) {
    var clean = {};
    if (!data || typeof data !== 'object') return clean;
    for (var i = 0; i < THIRD_PARTY_ALLOWED_KEYS.length; i++) {
      var key = THIRD_PARTY_ALLOWED_KEYS[i];
      var value = data[key];
      if (value === undefined || value === null) continue;
      if (typeof value === 'number' || typeof value === 'boolean') {
        clean[key] = value;
      } else if (key === 'content_name' || key === 'input_type' || key === 'contact_type') {
        clean[key] = String(value);
      }
    }
    return clean;
  }

  function track(instance, eventName, data) {
    var fbStandard = data && data._fbStandard;
    var fbEventId = data && data._fbEventId;
    var gaEvent = (data && data._gaEvent) || eventName;
    var payload = sanitizeThirdPartyPayload(data);

    try {
      if (typeof fbq === 'function') {
        if (fbStandard) {
          fbq('track', fbStandard, payload, fbEventId ? { eventID: fbEventId } : {});
        } else {
          fbq('trackCustom', eventName, payload);
        }
      }
    } catch (e) { /* analytics is best-effort; never block the flow */ }

    try {
      if (typeof gtag === 'function') {
        gtag('event', gaEvent, payload);
      }
    } catch (e) { /* analytics is best-effort; never block the flow */ }
  }

  window.TaraConsultationAnalytics = Object.freeze({
    track,
  });
})();
